__turbopack_context__.v({
  "main": "ProcessingDCBPayment-module__cSpMcq__main",
});
